<template>
    <div class="congratulations-div">
        <div class='congratulations-page-img'>
            <img v-if="!$getState('corporation')['is']" :srcset="
                `${$store.state.appUrl}/img/pwa/congratulations/thanku-1.png, ${$store.state.appUrl}/img/pwa/congratulations/thanku-1@2x.png`
            " :src="
    `${$store.state.appUrl}/img/pwa/congratulations/thanku-1.png`
" alt="Thrive Congratulations" />
            <div v-else class="qr-bg-color"></div>
            <div class='congratulations-msg'>
                <div class='congratulations-msg-1'>
                    <img class='congratulations-msg-img' :srcset="
                        `${$store.state.appUrl}/img/pwa/congratulations/thanku-3.svg, ${$store.state.appUrl}/img/pwa/congratulations/thanku-3.svg`
                    " :src="
    `${$store.state.appUrl}/img/pwa/congratulations/thanku-3.svg`
" alt="Thrive Congratulations" />
                    <h2>
                        <span class='text-primary font-bold'>{{ $t("Congratulations") }}</span>
                        <span class='congratulations-txt-1'>{{ $t("you are now a") }}</span>
                        <span class='congratulations-txt'>{{ $t("change maker!") }}</span>
                    </h2>
                </div>

                <button class='btn congratulations-btn' v-ripple @click="dashboardRedirect">
                    <img :src="`${$store.state.appUrl}/img/pwa/congratulations/thanku-2.svg`" />
                    <span>{{ $t("Go to Dashboard") }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Finished",

    components: {

    },

    mounted() {

    },

    methods: {
        dashboardRedirect: function () {
            this.$router.push("/device-selection");
        },
    }
};
</script>
